/**
 * Нормализация тегов — одна на сервер, оптимистичный редьюсер и поля ввода.
 *
 * Без общей функции стороны разъезжались бы молча: форма срезала `#`, а ядро нет, и агент,
 * приславший `#work`, получал тег, который рисуется как `##work` и не находится по `work`.
 * Оптимистичная реплика тоже обязана считать так же, как сервер, иначе тег «перескочит»
 * при следующем pull.
 *
 * Запятая внутри тега запрещена разрезанием, а не отказом: это разделитель и в поле ввода,
 * и в query-строке REST (`?tags=a,b`). Регистр значим — `Work` и `work` разные теги;
 * понижать регистр значило бы переписывать то, что человек набрал.
 */
export function normalizeTags(tags: readonly string[]): string[] {
	const out: string[] = [];
	for (const raw of tags) {
		for (const part of raw.split(",")) {
			const tag = part.trim().replace(/^#+/, "").trim();
			if (tag !== "" && !out.includes(tag)) {
				out.push(tag);
			}
		}
	}
	return out;
}
